<template>

  <div class="search whaty-search-select" v-clickoutside="handleClose">
    <div :class="['input-wrap', selectDropShow && 'active']"
         @mouseenter="hovering = true"
         @mouseleave="hovering = false">
        <input v-model="selectValue"
               style="display:none;"
               >
        <input class="form-control" type="text"
               v-model="selectValueShow"
               @click="handleFocus"
               readonly="readonly"
               ref="mySelect"
               style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
               autocomplete="off" :placeholder="dataParameter.name"
        >

      <div class="input-append select-icon" @click="handleFocus">
        <a data-role="select" class="btn btn-icon"><i class="mng icon-arrow-down-fill"></i></a>
      </div>

      <!--      </div>-->
      <div v-if="nannSearch" @click="handleFocus" class="nann-tip-wrapper">
        <el-tag v-if="nannSearch === '!null'" size="mini">已填写</el-tag>
        <el-tag v-if="nannSearch === 'null'" size="mini">未填写</el-tag>
      </div>
      <span class="el-input__suffix" style="margin-right: 14px;">
        <span class="el-input__suffix-inner">
          <i v-if="showClear" @click="clear" class="el-input__icon el-icon-circle-close el-input__clear"></i>
        </span>
      </span>


      <whaty-dropdown ref="myPopper" v-show="selectDropShow" v-model="selectDropShow" :reference-name="'mySelect'"
                      class="whaty-search-select-drop">
        <div class="drop" :style="dropStyle">
        <div class="drop-top drop-fix">
          <ul data-action="activeCurrent">
            <li class="drop-list" @click="handleNANNSearchChange('!null')">
              <a :class="{active: nannSearch === '!null'}"
                 href="javascript:;" class="drop-link" data-role="activeTarget">
<!--                <i class="mng icon-solidcircle drop-ico-pre"></i>-->
                <span class="drop-txt">已填写</span>
<!--                <i class="mng icon-tick-stroke drop-ico-tick drop-ico-suf"></i>-->
              </a>
            </li>
            <li class="drop-list" @click="handleNANNSearchChange('null')">
              <a :class="{active: nannSearch === 'null'}"
                 href="javascript:;" class="drop-link" data-role="activeTarget">
<!--                <i class="mng icon-hollowcircle drop-ico-pre"></i>-->
                <span class="drop-txt">未填写</span>
<!--                <i class="mng icon-tick-stroke drop-ico-tick drop-ico-suf"></i>-->
              </a>
            </li>
          </ul>
        </div>
        <div class="drop-mid" v-if="this.selectType === 'select'">
          <div class="drop-form-row">
            <div class="form-con form-dark">
              <div class="input-wrap input-hasicon">
                <span class="input-icon"><i class="mng icon-zoom"></i></span>
                <input name="form-name" autocomplete="off" type="text"
                       style="padding-left: 32px"
                       class="form-control rounded"
                       v-model.trim="optionSearchInputVal"
                       value="" placeholder="请输入关键词">
              </div>
            </div>
          </div>
        </div>
        <div class="drop-mid" v-show="dropIsData">
          <div class="drop-field" v-if="this.selectType === 'select'">
            <span class="pull-left drop-txt">全选</span>
            <label class="pull-right drop-checkbox form-label " :class="{'active':allChecked}">
              <span class="form-checkbox-btn" style="margin-right: 1px"><i class="mng icon-tick-stroke"></i></span>
              <input type="checkbox" v-model="allChecked" @click="handleAllCheckbox">
            </label>
          </div>
          <el-scrollbar ref="scrollbar" class="whaty-scroll">
            <ul class="drop-list-wrap">
              <li v-for="selectContent in selectDataList[this.dataParameter.uid]"
                  class="drop-list" v-show="selectContent.show === undefined || selectContent.show"
                  @click="toggleSelected(selectContent)"
              >
                <a class="drop-link has-tick" :class="{'drop-select': checkNames.includes(selectContent[1])}">
                  <span class="drop-txt" style="word-break: break-all">{{selectContent[1]}}</span>
                  <i class="mng icon-tick-stroke drop-ico-tick drop-ico-suf"></i>
                </a>
              </li>
            </ul>
          </el-scrollbar>
        </div>
        <div class="drop-mid" v-show="!dropIsData">
          <div class="empty-wrap drop-empty-wrap">
            <div class="empty-wrap">
              <span class="empty-icon"><img src="./empty-file.png" alt=""></span><br><span class="empty-text" onselectstart="return false" style="-moz-user-select:none;">{{dropNoDataText || noDateText || '暂无数据'}}</span>
            </div>
            <i class="assist"></i>
          </div>
        </div>
        <div class="drop-bot text-center" v-if="this.selectType === 'select'">
          <a href="javascript:" class="btn btn-solid-primary" @click="submitData">确定</a>
        </div>
      </div>
      </whaty-dropdown>
    </div>
  </div>
</template>



<script>
  import util from '../../libs/util'
  import Clickoutside from 'element-ui/src/utils/clickoutside'
  import WhatyDropdown from '../whaty-dropdown/whaty-dropdown'
  import pinyin from 'pinyin-match'

  let _ = require('lodash')

  export default {
    name: 'whaty-search-select',
    components: {WhatyDropdown},
    directives: { Clickoutside },
    props: {
      gridConfig: {
        type: Object,
        default() {
          return {}
        }
      },
      gridConfigUrl: {
        type: String,
        default: ''
      },
      value: [String, Number],
      size: {
        type: String,
        default: 'mini'
      },
      dataParameter: {
        type: Object,
        default() {
          return {}
        }
      },
      noDateText: {
        type: String
      },
      searchParams: {
        type: Object,
        default() {
          return {}
        }
      },
      fatherDataList: {
        type: Object,
        default() {
          return {}
        }
      },
      selectType: {
        type: String,
        default: 'select'
      }
    },
    data() {
      return {
        selectLoadingMap: {}, // select字段的loading状态
        selectDataList: {}, // 下拉框数据储存对象
        selectValue: '',
        selectValueShow: '',
        selectDropShow: false, // 下拉框是否显示
        nannSearch: '', // nann: null and not null, !null: 已填写, null: 未填写
        focused: false,
        hovering: false,
        checkNames: [], // 选中的选项
        optionSearchInputVal: '', // 下拉框搜索内容
        dropIsData: true, // 下拉框是否有数据
        dropNoDataText: '',
        allChecked: false, // 下拉全选标识
        contentValue: '', // 选择提示
        paramsData: {} // 调用后台参数用于比较前后参数是否相同，防止重复调用接口
      }
    },
    computed: {
      selectDataUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'selectData')
      },
      dropStyle() {
        return {
          'width': '206px',
          'left': 0
        }
      },
      showClear() {
        return ((this.selectValue && this.selectValue.length > 0) || this.nannSearch) &&
          (this.focused || this.hovering)
      },
      uidColumnMap: function () {
        let map = {}
        if (this.gridConfig.listColumnConfig && this.gridConfig.listColumnConfig.length > 0) {
          this.gridConfig.listColumnConfig.forEach(item => {
            map[item.uid] = item
          })
        }
        return map
      },
      contentShow() {
        return !this.contentValue.length
      }
    },
    created() {
      this.selectValue = this.value
    },
    mounted() {
      this.popperElm = this.$refs.myPopper.$el
    },
    methods: {
      handleFocus() { // 下拉框选中状态
        // 如果已经展示则关闭
        if (this.selectDropShow) {
          this.selectDropShow = false
          return
        }
        try {
          if (this.dataParameter.dependColumns && this.dataParameter.dependColumns.length > 0) {
            let dependColumnName = ''
            this.dataParameter.dependColumns.forEach(uid => {
              let column = this.uidColumnMap[uid]
              let key = column.dataIndex
              let value = this.searchParams[key]
              if (!value || value === 'null' || value === '!null') {
                if (dependColumnName) {
                  dependColumnName += '、'
                }
                dependColumnName += column.name
              }
            })
            if (dependColumnName) {
              this.dropNoDataText = '请先选择：' + dependColumnName
              this.dropIsData = false
              this.selectDropShow = true
              this.paramsData = {}
              return
            }
          }
          let params = {
            actionId: this.gridConfig.gridId,
            'columnDataIndex': this.dataParameter.dataIndex
          }
          // 补充级联参数
          if (this.dataParameter.dependColumns && this.dataParameter.dependColumns.length > 0) {
            let dependColumnValues = {}
            this.dataParameter.dependColumns.forEach(uid => {
              let key = this.uidColumnMap[uid].dataIndex
              let value = this.searchParams[key]
              let selectParameter = []
              if (value) {
                let sd = this.fatherDataList[this.uidColumnMap[uid].uid]
                if (sd) {
                  let reg = new RegExp('= ', 'g')
                  let valueList = (value.replace(reg, '')).split(' or ')
                  for (let j = 0; j < valueList.length; j++) {
                    for (let i = 0; i < sd.length; i++) {
                      if (valueList[j] === sd[i][1]) {
                        selectParameter.push(sd[i][0])
                      }
                    }
                  }
                  dependColumnValues[this.uidColumnMap[uid].dataIndex_] = selectParameter
                }
              }
            })
            params.dependColumnValues = dependColumnValues
          }
          // 判断是否是同一参数 同一参数则不用重复调用接口
          if (!Object.is(JSON.stringify(params), JSON.stringify(this.paramsData))) {
            util.ajax.post(this.selectDataUrl, {params}).then((res) => {
              if (res.data.meta.errCode === 0) {
                if (res.data.data && res.data.data.length > 0) {
                  this.dropIsData = true
                } else {
                  this.dropIsData = false
                }
                this.$set(this.selectDataList, this.dataParameter.uid, res.data.data)
              } else {
                this.dropIsData = false
                this.$notify.error({title: '错误', message: res.data.data})
              }
              this.$set(this.selectLoadingMap, this.dataParameter.uid, false)
              this.selectDropShow = true
              this.paramsData = params
            }).catch((e) => {
              this.selectDropShow = true
              this.dropIsData = false
              this.$set(this.selectLoadingMap, this.dataParameter.uid, false)
              console.error('获取下拉框数据失败！ ' + e)
            })
          } else {
            this.selectDropShow = true
          }
        } catch (e) {
          console.log(e)
        }
      },
      handleClose() { // 点击空白处
        this.selectDropShow = false
        this.optionSearchInputVal = ''
      },
      clear() { // clear btn click event
        this.selectValue = ''
        this.nannSearch = ''
        this.checkNames = []
        this.selectValueShow = ''
        this.contentValue = ''
        this.emitInput()
      },
      handleNANNSearchChange(mode) { // 选择NANN搜索事件
        this.selectValue = ''
        this.selectValueShow = ''
        this.checkNames = []
        this.nannSearch = mode
        this.selectDropShow = false
        this.emitInput()
      },
      toggleSelected(item) { // 切换选择状态
        let name = item[1]
        if (this.selectType === 'single_select') {
          this.checkNames = []
          this.checkNames.push(name)
          this.submitData()
        }
        if (this.checkNames.includes(name)) {
          for (let i = 0; i < this.checkNames.length; i++) {
            if (this.checkNames[i] === name) {
              this.checkNames.splice(i, 1)
            }
          }
        } else {
          this.checkNames.push(name)
        }
      },
      submitData() {
        for (let i = 0; i < this.checkNames.length; i++) {
          if (i === 0) {
            this.selectValue = this.checkNames[i]
            this.selectValueShow = this.checkNames[i]
          } else {
            this.selectValue = this.selectValue + ' or ' + this.checkNames[i]
            this.selectValueShow = this.selectValueShow + ',' + this.checkNames[i]
          }
        }
        if (this.checkNames.length === 0) {
          this.selectValue = ''
          this.selectValueShow = ''
        }
        this.nannSearch = ''
        this.selectDropShow = false
        this.optionSearchInputVal = ''
        this.emitInput()
      },
      emitInput() {
        let value = this.getValue()
        this.$emit('select-data-change', this.selectDataList[this.dataParameter.uid])
        this.$emit('input', value)
        this.emitChange(value)
      },
      getValue() {
        let value = ''
        if (this.nannSearch) {
          value = this.nannSearch
        } else if (this.selectValue) {
          value = '= ' + this.selectValue.replace(/or /g, 'or = ')
        }
        return value
      },
      searchOption: _.debounce( // 菜单搜索
        function () {
          let isData = false
          for (let i = 0; i < this.selectDataList[this.dataParameter.uid].length; i++) {
            let dataList = this.selectDataList[this.dataParameter.uid]
            let res = this.searchOptionContent(dataList[i])
            if (res) {
              isData = true
            }
          }
          this.dropIsData = isData
          this.allCheckedShow()
          this.$nextTick(() => {
            this.$refs.scrollbar.update()
          })
        },
        500 // 用户输入结束判定延迟时间
      ),
      searchOptionContent(selectContent) { // 检索内容
        let show = true
        // 如果为空字符就不需要搜索
        if (this.optionSearchInputVal) {
          show = pinyin.match(selectContent[1], this.optionSearchInputVal)
        }
        this.$set(selectContent, 'show', show)
        return show
      },
      emitChange(val) {
        let a = this.value
        let b = val
        if (val && this.value) {
          a = this.value.replace(/= /g, '').split(' or ')
          b = val.replace(/= /g, '').split(' or ')
        }
        if (!util.valueEquals(a, b)) {
          this.$emit('change', val)
        }
      },
      handleAllCheckbox(e) {
        if (e.target.checked) {
          this.selectAll()
        } else {
          this.clearChecks()
        }
      },
      selectAll() {
        this.allChecked = true
        let selectData = this.checkNames
        this.checkNames = []
        this.selectDataList[this.dataParameter.uid].forEach((item) => {
          if (item.show || item.show === undefined) {
            this.checkNames.push(item[1])
          }
        })
        selectData.forEach((item) => {
          // 适配先单独选择，在通过筛选全选情况
          // 判断之前选择的数据是否在现在当前选择数据中，若不在则加到当前选择数据中
          if (!this.checkNames.includes(item)) {
            this.checkNames.push(item)
          }
        })
      },
      clearChecks() {
        this.allChecked = false
        let selectData = []
        this.selectDataList[this.dataParameter.uid].forEach((item) => {
          if (item.show || item.show === undefined) {
            selectData.push(item[1])
          }
        })
        // 适配先选择多个，再筛选取消全选情况
        // 判断所取消的是否在之前选择的数据中，若存在则删除掉
        selectData.forEach(item => {
          this.checkNames.splice(this.checkNames.findIndex(data => data === item), 1)
        })
      },
      allCheckedShow() {
        let selectData = []
        if (this.selectDataList[this.dataParameter.uid]) {
          this.selectDataList[this.dataParameter.uid].forEach((item) => {
            if (item.show || item.show === undefined) {
              selectData.push(item[1])
            }
          })
          this.allChecked = this.checkNames != null && this.checkNames.length !== 0 &&
            selectData.every(item => this.checkNames.includes(item))
        }
      }
    },
    watch: {
      value: function (newValue) {
        if (newValue === undefined || newValue === '') {
          this.clear()
        } else if (newValue === 'null' || newValue === '!null') { // if val equal nannSearch
          this.nannSearch = newValue
        } else {
          this.selectValue = newValue
          this.selectValueShow = newValue.replace(/= /g, '').replace(/ or /g, ',')
          if (this.selectValueShow !== 'null' && this.selectValueShow !== '!null') {
            let nameArray = this.selectValueShow.split(',')
            this.checkNames = []
            for (let i = 0; i < nameArray.length; i++) {
              this.checkNames.push(nameArray[i])
            }
          }
        }
        this.contentValue = this.checkNames === undefined || this.checkNames == null || this.checkNames.length <= 0
                                                ? '' : this.dataParameter.name + ':已选' + this.checkNames.length + '条'
        this.$emit('content-value', this.contentValue)
      },
      optionSearchInputVal: function () { // 菜单搜索
        this.searchOption()
      },
      checkNames: function () { // 选中行数变化
        this.allCheckedShow()
      }
    }
  }
</script>
<style src="./index.scss" lang="scss"></style>




// WEBPACK FOOTER //
// src/components/whaty-search-select/index.vue